/** @format */
import { FilterTextField, FilterSelective, FilterTimeRange, FilterDateRange } from 'components';
import { TableItemActionsNew } from 'components';
const status = [
  {
    label: 'همه',
    value: '',
  },
  {
    label: 'موفق',
    value: 'true',
  },
  {
    label: 'ناموفق',
    value: 'false',
  },
];

const columns = (handleOpenDialog, navigate , currencyText) => [
  {
    title: 'شناسه سرویس',
    field: 'serviceId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },
  {
    title: 'نام سرویس',
    field: 'serviceName',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'تاریخ فراخوانی',
    field: 'calledDate',
    align: 'center',
    filterComponent: (props) => <FilterDateRange size="small" {...props} />,
  },
  {
    title: 'زمان فراخوانی',
    field: 'calledTime',
    align: 'center',
    filterComponent: (props) => <FilterTimeRange size="small" {...props} />,
  },
  {
    title: 'وضعیت',
    field: 'status',
    align: 'center',
    filterComponent: (props) => <FilterSelective options={status} size="small" {...props} />,
  },
  {
    title: 'سرویس گیرنده',
    field: 'serviceReceiver',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: `قیمت (${currencyText})`,
    field: 'price',
    align: 'center',
    filterComponent: (props) => <FilterTextField size="small" {...props} />,
  },
  {
    title: 'شماره فاکتور',
    field: 'factorId',
    align: 'center',
    filterComponent: (props) => <FilterTextField isInteger size="small" {...props} />,
  },

  {
    title: 'عملیات',
    field: 'actions',
    filtering: false,
    sorting: false,
    align: 'right',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rowData) => (
      <TableItemActionsNew
        iconButton
        title=""
        otherMenus={[
          {
            title: 'مجموعه سرویس',
            isShow: true,
            onClick: () => {
              handleOpenDialog(rowData.serviceId)
            },
          },
          {
            title: 'جزئیات فاکتور',
            isShow: true,
            onClick: () => {
              navigate(`/Invoice/${rowData.factorId}/invoice-details`)
            },
            disabled: !rowData.factorId,
          },
        ]}
      />
    ),
  },

];

const columnsId = {
  serviceId: '1310',
  serviceName: '1306',
  calledTime: ['1439', '1440'],
  status: '1441',
  serviceReceiver: '1307',
  price: ['1308', '1309'],
  serviceSet: '1307',
  factorId: '1311',
};

export { columns, columnsId };
